import { IonSpinner } from '@ionic/react';
import * as React from 'react';
import { Container } from './container';

export const Loading: React.FC = () => {
    return <Container center width={{value: 130, units: 'px'}} height={{value: 45, units: 'px'}}>
     <h6 className="ion-margin-start">Loading</h6><IonSpinner style={{marginTop: '15px'}} name="dots" />
 </Container>
}